import { createSliceContext } from "./CreateSliceContext";

interface SiteOffersSliceProps {
  relationships: {
    offers?: Array<any>;
  };
  location?: Location;
  field_subtitle?: string;
  field_title?: string;
  field_description?: string;
}

const defaultSiteOffersSliceValues: SiteOffersSliceProps = {
  relationships: { offers: [] },
  location: undefined,
  field_subtitle: "",
  field_title: "",
  field_description: "",
};

export const {
  Provider: SiteOffersSliceProvider,
  useContext: useSiteOffersSliceContext,
} = createSliceContext<SiteOffersSliceProps>(
  "SiteOffers",
  defaultSiteOffersSliceValues
);
